/* Blade detailing hub: add to cart from a card, the size picker and the row arrows.
   Loaded by every blade-hub-* section, so it guards against running twice. */
(function () {
  'use strict';
  if (window.BladeHub) return;
  window.BladeHub = true;

  var addUrl = ((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add') + '.js';
  var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  var sheet = null, toast = null, toastTimer = 0, opener = null, current = null;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function setting(name, fallback) {
    var n = document.querySelector('[data-bhub-' + name + ']');
    return n ? n.getAttribute('data-bhub-' + name) : fallback;
  }

  /* ---- message ---- */
  function say(msg, isError) {
    if (!toast) {
      toast = el('div', 'bhub bhub-toast');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.hidden = true;
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) {
        if (e.target.closest('.bhub-toast-btn')) { toast.hidden = true; openCart(); }
      });
    }
    toast.classList.toggle('is-error', !!isError);
    toast.innerHTML = '<span>' + esc(msg) + '</span>' + (isError ? '' : '<button type="button" class="bhub-toast-btn">View cart</button>');
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, isError ? 5000 : 3500);
  }
  function openCart() {
    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle && document.getElementById('Cart-Drawer')) toggle.click();
    else window.location.href = cartUrl;
  }

  /* ---- add to cart ---- */
  function add(variantId, btn, label) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add this to your cart.');
        /* the theme listens for this and redraws the drawer and the cart count */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        done(btn);
        if (setting('after-add', 'stay') === 'drawer') setTimeout(openCart, 450);
        else say('Added to cart: ' + label);
      })
      .catch(function (err) { say(err.message || 'Could not add this to your cart.', true); })
      .then(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
      });
  }
  function done(btn) {
    if (!btn || btn.dataset.bhubOld) return;
    btn.dataset.bhubOld = btn.innerHTML;
    var ghost = btn.classList.contains('bhub-btn--ghost');
    btn.classList.remove('bhub-btn--ghost');
    btn.classList.add('is-done');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>Added';
    setTimeout(function () {
      btn.classList.remove('is-done');
      if (ghost) btn.classList.add('bhub-btn--ghost');
      btn.innerHTML = btn.dataset.bhubOld;
      delete btn.dataset.bhubOld;
    }, 1600);
  }

  /* ---- size picker ---- */
  function litres(title) {
    var m = /(\d+(?:\.\d+)?)\s*(ml|l|ltr|litre|litres)\b/i.exec(title || '');
    if (!m) return 0;
    var n = parseFloat(m[1]);
    return /^ml$/i.test(m[2]) ? n / 1000 : n;
  }
  /* Runs on every way out of the picker. It does not rely on the dialog's own
     close event, which some browsers deliver late or not at all. */
  function tidy() {
    document.documentElement.style.overflow = '';
    if (opener && document.contains(opener)) opener.focus();
  }
  function shut() {
    if (sheet && sheet.open) sheet.close();
    tidy();
  }
  function buildSheet() {
    sheet = el('dialog', 'bhub bhub-sheet');
    sheet.setAttribute('aria-labelledby', 'bhubSheetTitle');
    sheet.innerHTML =
      '<button type="button" class="bhub-sheet-x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="bhub-brand" data-s-brand></div>' +
      '<h3 class="bhub-sheet-title" id="bhubSheetTitle"></h3>' +
      '<form method="dialog" data-s-form><fieldset class="bhub-opts" data-s-opts></fieldset>' +
      '<button type="submit" class="bhub-btn">Add to cart</button></form>';
    document.body.appendChild(sheet);
    sheet.querySelector('.bhub-sheet-x').addEventListener('click', shut);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) shut(); });
    sheet.addEventListener('close', tidy);
    sheet.addEventListener('cancel', function () { setTimeout(tidy, 0); });
    sheet.querySelector('[data-s-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var picked = sheet.querySelector('input[name="bhub-v"]:checked');
      if (!picked || !current) return;
      var v = current.variants[Number(picked.value)];
      var btn = opener, title = current.title;
      shut();
      add(v.id, btn, title + ', ' + v.title);
    });
  }
  function choose(btn) {
    var host = btn.closest('[data-bhub-product]');
    var src = host && host.querySelector('script[data-bhub-data]');
    if (!src) return;
    try { current = JSON.parse(src.textContent); } catch (err) { return; }
    if (!sheet) buildSheet();
    if (typeof sheet.showModal !== 'function') { window.location.href = current.url; return; }
    opener = btn;
    var perUnit = host.getAttribute('data-bhub-unit') === '1';
    var symbol = current.symbol || '';
    sheet.querySelector('[data-s-brand]').textContent = current.vendor || '';
    sheet.querySelector('#bhubSheetTitle').textContent = current.title;
    var first = -1;
    var html = '<legend>' + esc(current.option || 'Option') + '</legend>';
    current.variants.forEach(function (v, i) {
      if (v.available && first < 0) first = i;
      var extra = '';
      if (v.unit) extra = ' · ' + v.unit;
      else if (perUnit) {
        var l = litres(v.title);
        if (l > 0) extra = ' · ' + symbol + (v.price / 100 / l).toFixed(2) + '/L';
      }
      if (v.compare) extra += ' · was ' + v.compare;
      html += '<label class="bhub-opt"><input type="radio" name="bhub-v" value="' + i + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '<small>' + esc(v.money + extra) + '</small></span></label>';
    });
    sheet.querySelector('[data-s-opts]').innerHTML = html;
    var radios = sheet.querySelectorAll('input[name="bhub-v"]');
    if (first >= 0) radios[first].checked = true;
    document.documentElement.style.overflow = 'hidden';
    sheet.showModal();
    if (first >= 0) radios[first].focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bhub-add]');
    if (a) {
      e.preventDefault();
      if (a.classList.contains('is-busy')) return;
      add(a.getAttribute('data-variant-id'), a, a.getAttribute('data-title') || 'item');
      return;
    }
    var c = e.target.closest('[data-bhub-choose]');
    if (c) { e.preventDefault(); choose(c); }
  });

  /* ---- row arrows, shown on wide screens only ---- */
  function rails(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.bhub-rail-wrap'), function (w) {
      if (w.dataset.bhubReady) return;
      w.dataset.bhubReady = '1';
      var rail = w.querySelector('.bhub-rail');
      var prev = w.querySelector('.bhub-rail-btn--prev');
      var next = w.querySelector('.bhub-rail-btn--next');
      if (!rail || !prev || !next) return;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function sync() {
        prev.disabled = rail.scrollLeft < 4;
        next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
      }
      function go(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: calm ? 'auto' : 'smooth' }); }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { rails(); });
  else rails();
  window.addEventListener('load', function () { rails(); });
  document.addEventListener('shopify:section:load', function (e) { rails(e.target); });
})();
